import React from 'react';
import { Building2, MapPin } from 'lucide-react';
import { useLanguage } from '../../../context/LanguageContext';
import './About.css';

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              {t('about.title')}
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              {t('about.description1')}
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              {t('about.description2')}
            </p>
            <div className="flex items-center gap-4 mb-6">
              <div className="bg-blue-100 p-3 rounded-lg">
                <MapPin className="h-6 w-6 text-brand-dark" />
              </div>
              <div>
                <p className="font-semibold text-gray-900">{t('about.location')}</p>
                <p className="text-gray-600">{t('about.address')}</p>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="aspect-square bg-brand-primary rounded-2xl shadow-2xl transform rotate-3"></div>
            <div className="absolute inset-0 bg-white rounded-2xl shadow-xl p-8 flex items-center justify-center">
              <div className="text-center">
                <Building2 className="h-24 w-24 text-brand-primary mx-auto mb-4" />
                <h3 className="text-3xl font-bold text-gray-900 mb-2">{t('about.established')}</h3>
                <p className="text-gray-600">{t('about.tagline')}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Our Global Group */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border-2 border-blue-100">
          <div className="text-center mb-12">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {t('about.globalGroup.title')}
            </h3>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              {t('about.globalGroup.subtitle')}
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="space-y-6">
              <div>
                <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                  <div className="w-2 h-2 bg-brand-primary rounded-full"></div>
                  {t('about.globalGroup.marketReach.title')}
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  {t('about.globalGroup.marketReach.description')}
                </p>
              </div>
              <div>
                <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                  <div className="w-2 h-2 bg-brand-primary rounded-full"></div>
                  {t('about.globalGroup.assetCoverage.title')}
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  {t('about.globalGroup.assetCoverage.description')}
                </p>
              </div>
            </div>
            <div className="space-y-6">
              <div>
                <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                  <div className="w-2 h-2 bg-brand-primary rounded-full"></div>
                  {t('about.globalGroup.expertTeam.title')}
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  {t('about.globalGroup.expertTeam.description')}
                </p>
              </div>
              <div>
                <h4 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                  <div className="w-2 h-2 bg-brand-primary rounded-full"></div>
                  {t('about.globalGroup.innovation.title')}
                </h4>
                <p className="text-gray-700 leading-relaxed">
                  {t('about.globalGroup.innovation.description')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
